import { useContext } from "react";
import AuthContext from "../context/AuthContext";

function useAuthContext() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("Auth hooks must be used within an AuthProvider.");
  }

  return context;
}

export function useAuth() {
  return useAuthContext();
}

export function usePermissions() {
  const {
    permissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  } = useAuthContext();

  return {
    permissions,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
  };
}

export function useCan(permissionCode) {
  const { hasPermission } = usePermissions();
  return hasPermission(permissionCode);
}
